import CHART_TYPES from '../charts'

export default {
  reportingStoreOverview: {
    charts: [
      {
        title: 'Total number of express editor sites with store',
        type: CHART_TYPES.CARD,
        name: 'TotalStoresAddedExpress'
      },
      {
        title: 'Total number of traditional editor sites with store',
        type: CHART_TYPES.CARD,
        name: 'TotalStoresAddedTraditional'
      },
      {
        title: 'Total number of express editor sites published with store',
        type: CHART_TYPES.CARD,
        name: 'TotalStoresPublishedExpress'
      },
      {
        className: 'grid-col-12'
      },
      {
        title: 'Stores with products',
        type: CHART_TYPES.PIE,
        name: 'storeswithproducts',
        tooltipLabel: 'stores'
      },
      {
        title: 'Orders with products',
        type: CHART_TYPES.PIE,
        name: 'orderswithproducts',
        tooltipLabel: 'orders'
      },
      {
        title: 'Top Countries',
        type: CHART_TYPES.PIE,
        name: 'topstorecountries',
        tooltipLabel: 'stores'
      },
      {
        title: 'Top Store Language',
        type: CHART_TYPES.PIE,
        name: 'topstorelanguage',
        tooltipLabel: 'stores'
      },
      {
        title: 'Functionality',
        type: CHART_TYPES.STACKED_FEATURES,
        name: 'featuresinstores',
        yAxis: 'Number of stores'
      },
      {
        title: 'Payment Providers',
        type: CHART_TYPES.STACKED_FEATURES,
        name: 'paymentprovidersinstores',
        yAxis: 'Number of stores'
      },
      {
        title: 'Shipping Providers',
        type: CHART_TYPES.STACKED_FEATURES,
        name: 'shippingprovidersinstores',
        yAxis: 'Number of stores'
      },
      {
        title: 'Stores per Brand',
        type: CHART_TYPES.TABLE,
        name: 'StoresPerBrand'
      }
    ],
    route: '/financial-reports/store/overview',
    hideDatePicker: true
  },

  reportingStoreNewStores: {
    charts: [
      {
        title: 'Stores added express',
        type: CHART_TYPES.GRAPH,
        visible: ['Total'],
        name: 'StoreFirstAddedExpress'
      },
      {
        title: 'Express editor sites published with a store for the first time',
        type: CHART_TYPES.GRAPH,
        visible: ['Total'],
        name: 'StoreFirstPublishesExpress'
      },
      {
        title: 'Latest stores express',
        type: CHART_TYPES.TABLE,
        name: 'StoresCreatedExpress'
      },
      {
        title: 'Stores added traditional',
        type: CHART_TYPES.GRAPH,
        visible: ['Total'],
        name: 'StoreFirstAddedTraditional'
      },
      {
        title: 'Latest stores traditional',
        type: CHART_TYPES.TABLE,
        name: 'StoresCreatedTraditional'
      },
      {
        title: 'Stores customers',
        type: CHART_TYPES.TABLE,
        name: 'StoresCustomers'
      }
    ],
    route: '/financial-reports/store/newstores'
  },
  reportingStoreOrdersSales: {
    charts: [
      {
        title: 'Store orders and revenue',
        type: CHART_TYPES.GRAPH,
        name: 'StoresOrdersAndRevenue',
        doubleYAxis: true,
        yAxis: ['Amount', 'Orders']
      },
      {
        title: 'Orders per payment provider',
        name: 'StoresOrdersPerPaymentProvider',
        type: CHART_TYPES.PIE,
        className: 'grid-col-4'
      },
      {
        title: 'Revenue per payment provider',
        name: 'StoresRevenuePerPaymentProvider',
        type: CHART_TYPES.PIE,
        className: 'grid-col-4'
      },
      {
        title: 'Stores with orders',
        name: 'StoresWithOrders',
        type: CHART_TYPES.PIE,
        className: 'grid-col-4'
      },
      {
        title: 'Stores with at least one order',
        name: 'StoresWithAtleastOneOrder',
        type: CHART_TYPES.GRAPH
      },
      {
        title: 'Stores with most revenue',
        type: CHART_TYPES.TABLE,
        name: 'StoresWithMostRevenue'
      },
      {
        title: 'Latest store orders',
        type: CHART_TYPES.TABLE,
        name: 'LatestStoreOrders'
      }
    ],
    route: '/financial-reports/store/orders-sales'
  }
}
